import { createSlice } from '@reduxjs/toolkit';

const notificationSlice = createSlice({
    name: 'notification',
    initialState: {
        unreadCount: 0,
    },
    reducers: {
        setUnreadCount: (state, action) => {
            state.unreadCount = action.payload;
        },
    },
});

export const { setUnreadCount } = notificationSlice.actions;
export default notificationSlice.reducer;
